import { apiClient } from './api'
import type { ApiResponse } from '@/types/api'

// M4-C2: the raw signed token is NEVER returned from the server. Clients only
// ever see the presigned image URL (which embeds the token inside the PNG).
export interface QRCodeData {
  enrollmentId: string
  batchId: string
  imageUrl: string
  expiresAt: string
  generatedAt: string
  regeneratedAt?: string | null
}

export interface ScanResult {
  id: string
  batchId: string
  sessionId: string
  studentId: string
  status: string
  timestamp: string
  qrScannedAt?: string
}

export const qrCodeService = {
  getForEnrollment: async (
    enrollmentId: string,
  ): Promise<ApiResponse<QRCodeData>> =>
    apiClient.get(`/me/enrollments/${enrollmentId}/qr-code`),

  regenerate: async (
    enrollmentId: string,
  ): Promise<ApiResponse<QRCodeData>> =>
    apiClient.post(`/me/enrollments/${enrollmentId}/qr-code/regenerate`),

  /** Admin scans a decoded QR token against a schedule. */
  scan: async (
    qrToken: string,
    scheduleId: string,
  ): Promise<ApiResponse<ScanResult>> =>
    apiClient.post('/admin/attendance/scan', {
      qrToken,
      scheduleId,
    }),
}
